<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/modules/auth/stores/auth.store'

const authStore = useAuthStore()

const companyName = computed(() => authStore.companyData?.name)
</script>

<template>
  <div class="overflow-hidden px-1">
    <div
      class="flex justify-center items-center gap-x-2 bg-dss-secondary-400/60 rounded-[4px] transform -skew-x-12"
    >
      <Skeleton
        v-if="!companyName"
        width="50%"
        height="16px"
        class="my-3 skew-x-12"
      />
      <span
        v-else
        class="text-xs text-white font-bold py-3 skew-x-12"
      >
        {{ companyName }}
      </span>
    </div>
  </div>
</template>
